module.exports = __webpack_public_path__ + "img/hands-holding.53c94fba.svg";